import { useMutation, useQueryClient } from 'react-query'
import locationsApi from './actions'
import { locationsKeys } from './constants'

const useLocationsMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createLocation = useMutation(locationsApi.createLocation, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(locationsKeys.root(companyId))
    },
  })

  const updateLocation = useMutation(locationsApi.updateLocation, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(locationsKeys.root(companyId))
    },
  })

  const deleteLocation = useMutation(locationsApi.deleteLocation, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(locationsKeys.root(companyId))
    },
  })

  return { createLocation, updateLocation, deleteLocation }
}

export default useLocationsMutations
